module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_1.524c14c9.png";